import script from "./studentHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./studentHistory.vue?vue&type=script&setup=true&lang=js"

import "./studentHistory.vue?vue&type=style&index=0&id=5353d142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5353d142"]])

export default __exports__